import { FlexiButton } from "appworks/graphics/elements/flexi-button";
import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { AutoSpinsCountRadioControl } from "appworks/ui/controls/standard/radio/auto-spins-count-radio-control";
import { slotModel } from "slotworks/model/slot-model";

export class AgsAutoSpinsCountRadioControl extends AutoSpinsCountRadioControl {
    constructor(protected buttons: FlexiButton[], protected labels: FlexiText[], protected leftArrow?: FlexiButton, protected rightArrow?: FlexiButton) {
        super(buttons, labels, leftArrow, rightArrow);
    }

    protected override onChange(index: number, value: number): void {
        const { autoplay } = slotModel.read();
        if (value !== undefined) { autoplay.autoplays.lastSelectedValue = value; }
        slotModel.write({ autoplay });
    }
}